import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ModelTaskTableBodyRow from "./ModelTaskTableBodyRow";

const EmptyStateRow = ({ dataLength, columnCount }) => {
	const { t } = useTranslation();
	if (dataLength !== 0) return null;
	return <ModelTaskTableBodyRow columnCount={columnCount}>{t("label.noRecordsFound")}</ModelTaskTableBodyRow>;
};

EmptyStateRow.propTypes = {
	dataLength: PropTypes.number.isRequired,
	columnCount: PropTypes.number.isRequired,
};

export default EmptyStateRow;
